import PropTypes from 'prop-types';
import React, { createRef, PureComponent } from 'react';
import { connect } from 'react-redux';

import { validatePhoneNumber } from 'Util/Validator';

import FieldPhoneNumber from './FieldPhoneNumber.component';

/** @namespace PeggysagePwa/Component/FieldPhoneNumber/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    currentStoreCode: state.ConfigReducer.code
});

/** @namespace PeggysagePwa/Component/FieldPhoneNumber/Container/mapDispatchToProps */
export const mapDispatchToProps = () => ({});

/** @namespace PeggysagePwa/Component/FieldPhoneNumber/Container */
export class FieldPhoneNumberContainer extends PureComponent {
    static propTypes = {
        currentStoreCode: PropTypes.string,
        label: PropTypes.string,
        subLabel: PropTypes.string,
        inputProps: PropTypes.objectOf(PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.bool
        ])),
        errorMessage: PropTypes.string,
        onChange: PropTypes.func,
        hasFloatingLabel: PropTypes.bool
    };

    static defaultProps = {
        currentStoreCode: 'fr-FR',
        label: __('Phone number'),
        subLabel: '',
        inputProps: {
            id: 'telephone',
            name: 'telephone'
        },
        errorMessage: '',
        onChange: null,
        hasFloatingLabel: true
    };

    containerFunctions = {
        onChange: this.onChange.bind(this)
    };

    state = {
        // phoneNumber: '',
        errorMessage: ''
    };

    fieldRef = createRef();

    /**
     * If defaultValue is set (existing address), we need to manually trigger the phone input
     * to check its format (otherwise, an error is thrown at submit because the state in not set, and we cannot set it
     * manually because the number need the formatting of the phone-input component)
     */
    componentDidMount() {
        const { errorMessage, inputProps: { defaultValue } } = this.props;

        this.setState({ errorMessage });

        if (defaultValue !== '' && this.fieldRef.current) {
            const input = this.fieldRef.current.querySelector('input');
            if (input) {
                const value = this.formatDefaultValue(defaultValue);
                const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
                nativeInputValueSetter.call(input, value);
                const ev = new Event('input', { bubbles: true });
                input.dispatchEvent(ev);
            }
        }
    }

    componentDidUpdate(prevProps) {
        const { errorMessage } = this.props;
        const { errorMessage: prevErrorMessage } = prevProps;

        if (errorMessage !== prevErrorMessage && errorMessage !== '') {
            this.setState({ errorMessage });
        }
    }

    containerProps() {
        const {
            currentStoreCode, label, subLabel, inputProps, hasFloatingLabel
        } = this.props;
        const { errorMessage } = this.state;

        return {
            currentStoreCode,
            label,
            subLabel,
            inputProps,
            hasFloatingLabel,
            errorMessage,
            fieldRef: this.fieldRef
        };
    }

    /**
     * Prevent error with old numbers (like 0612345678)
     * @param defaultValue
     * @returns {string|*}
     */
    formatDefaultValue(defaultValue) {
        const { currentStoreCode } = this.props;

        // eslint-disable-next-line no-magic-numbers
        const countryCode = currentStoreCode.substr(3, 2).toLowerCase();

        // eslint-disable-next-line no-magic-numbers
        if (countryCode === 'fr' && defaultValue.length === 10 && defaultValue.substr(0, 1) === '0') {
            return `+33${defaultValue.substring(1)}`;
        }

        // eslint-disable-next-line no-magic-numbers
        if (countryCode === 'ch' && defaultValue.length === 10 && defaultValue.substr(0, 2) === '07') {
            return `+41${defaultValue.substring(1)}`;
        }

        return defaultValue;
    }

    onChange(value, country, _e, formattedValue) {
        const { onChange } = this.props;

        const result = validatePhoneNumber(value, country);

        this.setState({
            // phoneNumber: formattedValue,
            errorMessage: result !== true ? result : ''
        });

        if (onChange) {
            onChange(value, country, _e, formattedValue);
        }
    }

    render() {
        return (
            <FieldPhoneNumber
              { ...this.containerFunctions }
              { ...this.containerProps() }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FieldPhoneNumberContainer);
